// // ============================================================
// //
// // Vanilla Color Picker v 0.1.8
// //
// // http://github.com/miroshko/vanilla-color-picker
// //
// // This project is licensed under the terms of the MIT license.
// //
// // ============================================================
// !function(e){function t(e,t,i){var n=i?"vanilla-color-picker-single-color-picked":""
// return'<div class="vanilla-color-picker-single-color '+n+'" tabindex="'+t+'" data-color="'+e+'" style="background-color:'+e+'"></div>'}function i(){if(!document.getElementById("vanilla-color-picker-style")){var t=document.createElement("style")
// t.setAttribute("type","text/css"),t.setAttribute("id","vanilla-color-picker-style"),t.innerHTML=l
// var i=e.document.head.children[0]
// i?e.document.head.insertBefore(t,i):e.document.head.appendChild(t)}}function n(){this.subscribers={},this.on=function(e,t){return this.subscribers[e]=this.subscribers[e]||[],this.subscribers[e].push(t),this},this.emit=function(e){var t=arguments;(this.subscribers[e]||[]).forEach(function(e){e.apply(null,Array.prototype.splice.call(t,1))})}}function s(e,i,s){n.apply(this),this.targetElem=e,this.elem=null
// var o=this
// this._initialize=function(){this._createPickerElement(),this._positionPickerElement(),this._addEventListeners()},this.destroy=function(){try{this.elem.parentNode.removeChild(this.elem)}catch(e){}},this._positionPickerElement=function(){var e=this.targetElem.offsetLeft,t=this.targetElem.offsetTop,i=this.targetElem.offsetHeight
// this.elem.style.left=e+"px",this.elem.style.top=t+i+"px"},this._onFocusLost=function(){setTimeout(function(){o.elem.contains(document.activeElement)?document.activeElement.addEventListener("blur",o._onFocusLost):o.emit("lostFocus")},1)},this._createPickerElement=function(){this.elem=document.createElement("div"),this.elem.classList.add("vanilla-color-picker"),s&&this.elem.classList.add(s)
// for(var e=i.indexOf(this.targetElem.dataset.vanillaPickerColor),n=0;n<i.length;n++)this.elem.innerHTML+=t(i[n],n+1,n==e)
// this.targetElem.parentNode.appendChild(this.elem),this.elem.setAttribute("tabindex",1)
// var r=e>-1?e:0
// this.elem.children[r].focus(),this.elem.children[r].addEventListener("blur",o._onFocusLost)},this._addEventListeners=function(){var e=this
// this.elem.addEventListener("click",function(t){t.target.classList.contains("vanilla-color-picker-single-color")&&e.emit("colorChosen",t.target.dataset.color)}),this.elem.addEventListener("keydown",function(t){var i=13,n=27,s=t.which||t.keyCode
// s==i&&e.emit("colorChosen",t.target.dataset.color),s==n&&e.emit("lostFocus")})},this._initialize()}function o(e){n.apply(this),this.set=this.emit,this.colors=c,this.className="",this.elem=e,this.currentPicker=null
// var t=this
// this._initialize=function(){this._addEventListeners()},this._addEventListeners=function(){this.elem.addEventListener("click",this.openPicker),this.elem.addEventListener("focus",this.openPicker),this.on("customColors",function(e){if(!(e instanceof Array))throw new Error("Colors must be an array")
// t.colors=e}),this.on("defaultColor",function(e){t.elem.dataset.vanillaPickerColor||(t._updateElemState(e),t.emit("colorChosen",e,t.elem))}),this.on("className",function(e){t.className=e})},this._updateElemState=function(e){this.elem.dataset.vanillaPickerColor=e,this.elem.value=e},this.destroyPicker=function(){t.currentPicker&&(t.currentPicker.destroy(),t.currentPicker=null,t.emit("pickerClosed"))},this.openPicker=function(){t.currentPicker||(t.currentPicker=new s(t.elem,t.colors,t.className),t.currentPicker.on("colorChosen",function(e){t._updateElemState(e),t.destroyPicker(),t.emit("colorChosen",e,t.elem)}),t.currentPicker.on("lostFocus",function(){t.emit("lostFocus"),t.destroyPicker()}),t.emit("pickerCreated"))},this._initialize()}function r(e,t){return i(),new o(e,t)}var l=".vanilla-color-picker { display: inline-block; position: absolute; z-index: 100; padding: 5px; background-color: #fff; box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.3) } .vanilla-color-picker-single-color { display: inline-block; width: 20px; height: 20px; margin: 1px; border-radius: 2px; }",c=["red","yellow","green"]
// e.define&&e.define.amd?define([],function(){return r}):e.vanillaColorPicker=r}(this||window)

// /**
//  * Custom `color picker` extension
//  */
// var BardColorPickerExtension = MediumEditor.Extension.extend({
//     name: "colorPicker",

//     init: function () {
//         this.button = this.document.createElement('button');
//         this.button.classList.add('medium-editor-action');
//         this.button.classList.add('editor-color-picker');
//         this.button.title = 'Text color'
//         this.button.innerHTML = '<i class="fa fa-paint-brush"></i>';

//         this.on(this.button, 'click', this.handleClick.bind(this));
//     },

//     getButton: function () {
//         return this.button;
//     },

//     handleClick: function (e) {
//         e.preventDefault();
//         e.stopPropagation();

//         this.selectionState = this.base.exportSelection();

//         // If no text selected, stop here.
//         if (this.selectionState && (this.selectionState.end - this.selectionState.start === 0)) {
//             return;
//         }

//         // colors for picker
//         var pickerColors = [
//         // "#1abc9c",
//         // "#2ecc71",
//         // "#3498db",
//         // "#9b59b6",
//         // "#34495e",
//         // "#16a085",
//         // "#27ae60",
//         // "#2980b9",
//         // "#8e44ad",
//         // "#2c3e50",
//         // "#f1c40f",
//         // "#e67e22",
//         // "#e74c3c",
//         // "#bdc3c7",
//         // "#95a5a6",
//         // "#f39c12"
//             '#ffffff', '#C1C1C1', '#77777A', '#5D5D5D', '#000000', '#8D85C9', '#022169', '#26458B', '#008996', '#FF7F2E', '#B51783'
//         ];

//         var picker = vanillaColorPicker(this.document.querySelector(".medium-editor-toolbar-active .editor-color-picker").parentNode);
//         picker.set("customColors", pickerColors);
//         picker.set("positionOnTop");
//         picker.openPicker();
//         picker.on("colorChosen", function (color) {
//             console.log('chose', color);
//             this.base.importSelection(this.selectionState);

//             console.log('this.selectionState', this.selectionState)
//             // this.document.execCommand("styleWithCSS", false, true);
//             this.document.execCommand("foreColor", false, color);
//         }.bind(this));
//     }
// });

// // Add it to the Statamic object.
// Statamic.MediumEditorExtensions.colorPicker = BardColorPickerExtension;